import React from 'react';
import Dialog from '../../Dialogs/Dialog';

const PaymentFailureDialog = ({ onClose, message }) => {
    return (
        <Dialog onClose={onClose} title="Payment Failed" show={true} closeButton="false" closeButtonText="OK">
            {message}
        </Dialog>
    );
};

export default PaymentFailureDialog;
